module.exports = __webpack_public_path__ + "img/30-how-to-put-the-social.71fac095.jpg";